import React, { useContext, useRef, useEffect } from "react";
import { Logo } from "components";
import Nav from "./nav";
// No PropTypes import since it's not being used
import { appContext } from "providers/appProvider";
import { useResizeObserver } from "hooks";
import imgLogo from "images/logo.webp";
import { Link } from "gatsby";
import useDeviceSize from "hooks/useDeviceSize";
import Button from "../../Button";
import ExternalLink from "../../external-link";

const UtilityNavUSOnly = () => {
  return (
    <div className="header-top-text">
      <p>This site is intended for healthcare professionals only.</p>
    </div>
  );
};

const UtilityNavDesktop = () => {
  const { appConfigs } = useContext(appContext);
  const handlePageChange = () => {
    // Remove the function calls if they are not necessary
    // updateHeaderPageList([]);
    // updateNavActive(null);
  };
  return (
    <>
      <div className="link-wrapper">
        <a href="#main-content" className="skipToMainContent">
          Skip to Main Content
        </a>
        <a
          href={process.env.GATSBY_HCP_URL}
          target="_blank"
          rel="noreferrer"
        ></a>
        <Link to="#isiContainer" onClick={handlePageChange}>
          Important Safety Information
        </Link>
        <ExternalLink
          externalURL="https://dailymed.nlm.nih.gov/dailymed/fda/fdaDrugXsl.cfm?setid=3abfbffc-9e52-4fc6-ae92-6e0a97f4afe7&type=display"
          messageTitle={appConfigs.externalLinkInfoPI.TITLE}
          messageBody={appConfigs.externalLinkInfoPI.BODY}
          classNameLink="normal-link"
          classNameOverlay={appConfigs.externalLinkInfoPI.OVERLAY_CLASS_NAME}
        >
          Full Prescribing Information
        </ExternalLink>
      </div>
    </>
  );
};

const MainHeader = () => {
  const deviceSizes = useDeviceSize();
  return (
    <div className="main-header-content-wrapper">
      <div className="utility-nav">
        <div className="centered-content-lg">
          <div className="inner-content top-bar">
            <UtilityNavUSOnly />
            {deviceSizes?.xlUp ? <UtilityNavDesktop /> : <></>}
          </div>
        </div>
      </div>
      <div className="centered-content-lg">
        <div className="header-bottom">
          <div className="inner-content">
            <div className="logo-wrap">
              <Logo
                image={imgLogo}
                url="/"
                className="logo"
                width="240"
                height="74px"
                alt="Nalmefene HCl logo"
              />
            </div>
          </div>
          <div className="nav-button-wrapper">
            <Nav />
            <Button className="btn-primary" linkTo="/request-a-rep">
              Request Information
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

function Header({ indication, ...props }) {
  const { updateHeaderHeight, magicshot, appConfigs } = useContext(appContext);
  const headerRef = useRef(null);
  const elementSize = useResizeObserver(headerRef);
  const isHeaderFixed = appConfigs.siteOptions.HEADER_TYPE === "fixed";

  useEffect(() => {
    if (isHeaderFixed && elementSize.height !== 0) {
      updateHeaderHeight(elementSize.height);
      document.querySelector("html").style.scrollPaddingTop =
        Math.floor(elementSize.height) + "px";
    }
  }, [elementSize.height, isHeaderFixed, updateHeaderHeight]);

  return (
    <header
      {...props}
      className="header-wrapper"
      style={
        isHeaderFixed && !magicshot
          ? {
              position: "fixed",
              width: "100vw",
            }
          : {}
      }
      ref={headerRef}
    >
      <MainHeader />
    </header>
  );
}

export default Header;
